var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 16,
    viewBox: "0 0 27 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7.98645C22.814 11.0151 19.6745 15.9567 13.6049 15.9567C9.09667 15.9567 9.62797 12.7071 9.62797 8.30526C9.62797 3.90344 9.11519 -0.294584 13.6049 0.0162536C20.5117 0.49444 23.6512 5.43599 27 7.98645Z",
    fill: "#36C8F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.95911e-05 7.98645C4.186 4.95779 7.32553 0.0162449 13.3951 0.0162449C17.9033 0.0162449 17.372 3.26582 17.372 7.66764C17.372 12.0695 17.8848 16.2675 13.3951 15.9566C6.48832 15.4785 3.34879 10.5369 -4.95911e-05 7.98645Z",
    fill: "#36C8F6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3953,
    cy: 7.9864,
    rx: 5.02326,
    ry: 3.8257,
    fill: "#194FC6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIc);
export default __webpack_public_path__ + "static/media/eye-ic.de549f46d23a0ec709065e7594fecdb8.svg";
export { ForwardRef as ReactComponent };